export default `<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<g fill="currentColor"><circle class="st0" cx="324.4" cy="77.7" r="18.3"/>
<circle class="st0" cx="454.9" cy="66.3" r="18.3"/>
<circle class="st1" cx="387.2" cy="21.9" r="18.3"/>
<polyline class="st0" points="336,64.7 375.6,29.5 399.3,32.9 438.9,57 "/>
<path class="st2" d="M20.7,11.4c-0.9,0-1.7,0.4-2.2,1l-3.8-2.8c0.2-0.4,0.2-0.7,0.2-1.1c0-1.6-1.3-2.9-2.9-2.9
	c-1.6,0-2.9,1.3-2.9,2.9c0,0.6,0.2,1.1,0.4,1.5l-4.1,3.8c-0.5-0.5-1.2-0.8-2-0.8c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9
	s2.9-1.3,2.9-2.9c0-0.5-0.1-0.9-0.3-1.3l4.1-3.8c0.5,0.4,1.1,0.7,1.8,0.7c0.8,0,1.6-0.4,2.1-0.9l3.8,2.8c-0.1,0.3-0.2,0.7-0.2,1.1
	c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S22.3,11.4,20.7,11.4z M3.4,17.8c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9
	S4.4,17.8,3.4,17.8z M20.7,16.3c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9S21.7,16.3,20.7,16.3z"/></g>
</svg>`;
